<template>
  <div>
    <mu-container class="bottom">
      <mu-card>
        <van-row
          type="flex"
          justify="center"
          v-if="flow.role == 2"
          v-show="flow.status != 5"
        >
          <!-- <van-col span="24" v-if="flow.status == 0">
            <van-field
              class="comment"
              v-model="flowForm.comment"
              border
              placeholder="请填写审批意见……"
              left-icon="comment-circle-o"
              right-icon="warning-o"
            />
          </van-col> -->
          <van-col span="6" >
            <!-- <van-button
              @click="approve"
              :loading="is_loading"
              loading-text="提交中..."
              size="normal"
              type="primary"
              ><van-icon name="passed" />通过</van-button
            > -->
            <van-button
              @click="approve_show=true"
              size="normal"
              type="primary"
              ><van-icon name="passed" />通过</van-button
            >
            <!-- <van-grid-item icon="upgrade" text="已提交" /> -->
          </van-col>
          <!-- <van-col span="6">
            <van-button  size="normal" type="primary"><van-icon name="share-o" />加签</van-button>
        </van-col> -->
          <van-col span="6" v-if="flow.status == 0">
            <van-button @click="openUser" size="normal" type="primary"
              ><van-icon name="share-o" />转交</van-button
            >
            <!-- <van-grid-item icon="upgrade" text="已提交" /> -->
          </van-col>
          <van-col span="6" v-if="flow.status == 0">
            <van-button @click="refuse_show=true" size="normal" type="danger"
              ><van-icon name="close" />驳回</van-button
            >
          </van-col>
          <van-col span="6">
            <van-button @click="print" size="normal" type="primary"
              ><van-icon name="passed" />打印</van-button
            >
          </van-col>
        </van-row>

        <van-row type="flex" justify="center" v-else-if="flow.role == 1">
          <van-col span="6" v-if="flow.status == 0">
            <van-button @click="press" size="normal" type="primary"
              ><van-icon name="upgrade" />催办</van-button
            >
          </van-col>
          <van-col span="6" v-if="flow.status == 0">
            <van-button @click="recall" size="normal" type="info"
              ><van-icon name="down" />撤回</van-button
            >
          </van-col>
          <van-col span="6" v-if="flow.status != 1 && flow.catalog_id !=20" >
            <van-button @click="resubmit" size="normal" type="info"
              ><van-icon name="revoke" />重新提交</van-button
            >
          </van-col>
          <van-col span="6" v-if="flow.status == 1&& flow.catalog_id !=20">
            <van-button @click="resubmit" size="normal" type="info"
              ><van-icon name="revoke" />再次提交</van-button
            >
          </van-col>
          <van-col span="6">
            <van-button @click="print" size="normal" type="primary"
              ><van-icon name="passed" />打印</van-button
            >
          </van-col>
        </van-row>
        <van-row type="flex" justify="center" v-else-if="flow.role == 3">
          <!-- <van-col span="6">
          <van-button  size="normal" type="primary"><van-icon name="passed" />抄送转发</van-button>
        </van-col>-->
          <van-col span="8" v-if="flow.catalog_id == 10 && flow.status == 1">
            <van-button @click="refund_cancel" size="normal" type="warning"
              ><van-icon name="close" />作废</van-button
            >
          </van-col>
          <van-col span="8">
            <van-button
              size="normal"
              v-if="flow.is_pay != 1"
              @click="openConfirmPay"
              type="primary"
              ><van-icon name="passed" />确认已付款</van-button
            >
            <van-button size="normal" v-else disabled type="primary"
              ><van-icon name="passed" />已确认付款</van-button
            >
          </van-col>

          <van-col span="8">
            <van-button @click="print" size="normal" type="primary"
              ><van-icon name="passed" />打印</van-button
            >
          </van-col>
        </van-row>
        <van-row type="flex" justify="center" v-else>
          <van-col span="6">
            <van-button @click="print" size="normal" type="primary"
              ><van-icon name="passed" />打印</van-button
            >
          </van-col>
        </van-row>

        <!-- <van-popup  position="bottom" v-model="user.show">
      <van-search placeholder="请输入用户姓名" v-model="userForm.user" @input="getUser()"/>
      <van-picker 
        cancel-button-text='取消' 
        value-key="name"    
        show-toolbar 
        :columns="user.data"  
        @confirm="deliverTo"
        @cancel="user.show = false"
    />
    </van-popup> -->
        <mu-dialog
          transition="slide-bottom"
          fullscreen
          lock-scroll
          scrollable
          :open.sync="user.show"
        >
          <mu-paper :z-depth="1" class="demo-list-wrap">
            <div class="user_top">
              <mu-appbar color="indigo500">
                通讯录
                <mu-button icon slot="right">
                  <!-- <mu-icon :value="close"></mu-icon> -->
                  <van-icon name="close" @click="user.show = false" />
                </mu-button>
              </mu-appbar>

              <van-search
                placeholder="请输入用户姓名"
                v-model="userForm.user"
                @input="getUser()"
              />
            </div>
            <div class="user_content">
              <mu-list v-for="(items, key) in user.data" :key="key">
                <mu-sub-header>{{ key }}</mu-sub-header>
                <mu-list-item
                  avatar
                  button
                  :ripple="false"
                  v-for="item in items"
                  :key="item.userid"
                  @click="deliverTo(item)"
                >
                  <mu-list-item-action>
                    <mu-avatar>
                      <img :src="item.thumb_avatar" />
                    </mu-avatar>
                  </mu-list-item-action>
                  <mu-list-item-title>{{ item.name }}</mu-list-item-title>
                  <mu-list-item-sub-title>{{
                    item.position
                  }}</mu-list-item-sub-title>
                  <!-- <mu-list-item-action>
                <mu-icon :value="item.position"></mu-icon>
              </mu-list-item-action> -->
                </mu-list-item>
                <mu-divider></mu-divider>
              </mu-list>
            </div>
          </mu-paper>
        </mu-dialog>
      </mu-card>
      <van-popup
        v-model="confirm_pay_show"
        closeable
        close-icon="close"
        round
        position="bottom"
        style="height:42%;padding-top:20px;"
      >
      <van-form>
        
        <van-field
          v-model="flow.amount"
          name="总金额"
          label="总金额"
          disabled
        />
        <van-field
          v-model="flow.no_pay_amount"
          name="剩余金额"
          label="剩余金额"
          disabled
        />
        <van-field
          v-model="payer_bank_form.pay_amount"
          type="number"
          name="付款金额"
          label="付款金额"
          placeholder="请输入付款金额"
          required
          :rules="[{ required: true, message: '请填写付款金额' }]"
        />
        <van-field v-model="payer_bank_form.payer_bank" label="付款账号"  required size='large' placeholder="请选择付款账号" @click="payer_bank.show=true" readonly is-link/>
        <van-action-sheet v-model="payer_bank.show" :actions="payer_bank.options" @select="payer_bank_onselect" />
        
        <div style="margin: 16px;">
          <van-button  round block type="primary" @click="confirm_pay()">确认付款</van-button>
        </div>
      </van-form>
      </van-popup>
      <!-- 审核通过 -->
    <van-popup
      v-model="approve_show"
      closeable
      close-icon="close"
      round
      position="bottom"
      style="height: 42%; padding-top: 35px"
    >
      <van-form>
        <!-- <van-field
          class="comment"
          v-model="flowForm.comment"
          border
          placeholder="请填写审批意见……"
          left-icon="comment-circle-o"
         
        /> -->
        <van-field
          class="comment"
          v-model="flowForm.comment"
          label="审批意见"
          border
          placeholder="请填写审批意见……"
          left-icon="comment-circle-o"
          v-if="flow.is_pre_cost == null"
        />
        <van-field
          v-else
          v-model="flowForm.comment"
          rows="2"
          label="审批意见:"
          type="textarea"
          maxlength="50"
          placeholder="请输入审批意见……"
          show-word-limit
        />
        <div style="margin:30px 10px;text-align:center;" v-if="flow.is_pre_cost == null">
          <!-- <span>类型：</span> -->
          <van-radio-group name="审批类型" v-model="flowForm.is_pre_cost" direction="horizontal">
            <span style="margin-right:10px;">审批类型：</span>
            <van-radio name="预付">预付</van-radio>
            <van-radio name="费用">费用</van-radio>
            <!-- 发票冲账才有以下选项 -->
            <van-radio v-if="flow.catalog_id == 11" name="其他应付款-预提费用">其他应付款-预提费用</van-radio>
            <van-radio v-if="flow.catalog_id == 11" name="应付账款-暂估">应付账款-暂估</van-radio>
          </van-radio-group>

        </div>
        
        <div style="margin: 16px">
          <van-button
            round
            block
            type="primary"
            :loading="is_loading"
            @click="approve()"
            ><van-icon name="passed" />审批通过</van-button
          >
          <!-- <van-button
            round
            block
            @click="approve"
            :loading="is_loading"
            loading-text="提交中..."
            size="normal"
            type="primary"
            ><van-icon name="passed" />通过</van-button
          > -->
        </div>
      </van-form>
    </van-popup>
    <!-- 审核拒绝 -->
    <van-popup
      v-model="refuse_show"
      closeable
      close-icon="close"
      round
      position="bottom"
      style="height: 28%; padding-top: 35px"
    >
      <van-form>
        <van-field
          class="comment"
          v-model="flowForm.comment"
          border
          placeholder="请填写审批意见……"
          left-icon="comment-circle-o"
         
        />
        
        
        <div style="margin: 16px">
          <van-button
            round
            block
            type="danger"
            :loading="is_loading"
            @click="refuse()"
            ><van-icon name="close" />驳回审批</van-button
          >
        </div>
      </van-form>
    </van-popup>
    </mu-container>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    flow: Object,
    printObj: Object,
    users:Object,
  },
  data() {
    return {
      is_loading: false,
      flowForm: {
        comment: "",
        flow_id: this.$route.params.id,
        is_pre_cost:'',
      },
      user: {
        show: false,
        data: this.users,
      },
      userForm: {
        user: "",
      },
      deliverForm: {
        user: {},
        flow_id: "",
      },
      confirm_pay_show: false,
      pay_amount:this.flow.no_pay_amount,
      payer_bank:{
        show:false,
        options:[],
      },
      payer_bank_form:{
        pay_amount:this.flow.no_pay_amount,
        flow_id:this.$route.params.id,
        payer_bank:'',
        payer_bank_id:'',
      },
      approve_show:false,
      refuse_show:false,
    };
  },
  created() {
   
  },
  methods: {
    openConfirmPay(){
      this.confirm_pay_show = true
      this.getPayerBank();
    },
    //获取付款账号
    getPayerBank(){
      this.$http.post('payer_banks',this.flow)
      .then((res)=>{
        console.log(res)
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          });
          return false;
        }
        if(res.data.data.banks.length==0){
          this.$dialog.alert({
            message: '暂无付款账号，请联系管理员添加！',
          });
          return false;
        }
        this.payer_bank.options = res.data.data.banks
        if(res.data.data.default_bank){
          var bank = res.data.data.default_bank
          this.payer_bank_form.payer_bank = bank.bank_account+'/'+bank.bank
          this.payer_bank_form.payer_bank_id = bank.id
        }
      })
    },
    payer_bank_onselect(item){
      this.payer_bank.show = false;
      this.payer_bank_form.payer_bank = item.name;
      this.payer_bank_form.payer_bank_id = item.id;
      // // this.payment.department = item.name;
      // this.approverForm.department_id = item.Id;
      // this.getApprover();

    },
    //审批
    approve() {
      // console.log(this.flowForm)
      // console.log(this.flow.is_pre_cost)
      // console.log(this.flowForm.is_pre_cost)
      // if(this.flow.is_pre_cost)
      if((!this.flow.is_pre_cost)&&(!this.flowForm.is_pre_cost)){
        if(this.confirm_pay_form.payer_bank_id==''){
          this.$dialog.alert({
              message: '请选择审批类型！',
            });
            return false;
        }
      }
      
      
      this.is_loading = true;
      this.$http.put("/flow/approve", this.flowForm).then((res) => {
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          });
          return false;
        }
        this.$dialog
          .alert({
            message: res.data.msg,
          })
          .then(() => {
            this.$router.push({ name: "MyApproval" });
          });
      });
    },
    //拒绝
    refuse() {
      
      if (this.flowForm.comment == "") {
        this.$dialog.alert({
          message: "请填写审批意见……",
        });
        return false;
      }
      // console.log(this.flowForm)
      // return false;
      this.is_loading = true;
      this.$http.put("/flow/refuse", this.flowForm).then((res) => {
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          });
          return false;
        }
        this.$dialog
          .alert({
            message: res.data.msg,
          })
          .then(() => {
            this.$router.push({ name: "MyApproval" });
          });
      });
    },
    //撤销
    recall() {
      this.$http.put("/flow/recall", this.flowForm).then((res) => {
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          });
          return false;
        }
        this.$dialog
          .alert({
            message: res.data.msg,
          })
          .then(() => {
            this.$router.push({ name: "MyFlow" });
          });
      });
    },
    getUser() {
      this.$http.post("get_users", this.userForm).then((res) => {
        console.log(res);
        this.user.data = res.data.data;
      });
    },
    openUser() {
      this.user.show = true;
      this.getUser();
    },
    //审批转交
    deliverTo(user) {
      this.deliverForm.user = user;
      this.deliverForm.flow_id = this.flow.id;

      this.$confirm("确定将审批转交给：" + user.name + "?", "提示").then(
        ({ result }) => {
          if (!result) {
            return false;
          }
          this.$http.post("flow/deliver_to", this.deliverForm).then((res) => {
            this.user.show = false;
            this.userForm.user = "";
            if (res.data.code != 200) {
              this.$dialog.alert({
                message: res.data.msg,
              });
              return false;
            }
            this.$dialog
              .alert({
                message: res.data.msg,
              })
              .then((res) => {
                this.$router.push({ name: "MyApproval" });
              });
          });
        }
      );

      console.log(user);
    },
    //催办
    press() {
      this.$http.post("flow/press", { flow_id: this.flow.id }).then((res) => {
        console.log(res);
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          });
          return false;
        }
        this.$dialog.alert({
          message: res.data.msg,
        });
        return false;
      });
    },
    //确认付款
    confirm_pay() {
      
      
      if(this.payer_bank_form.payer_bank_id==''){
        this.$dialog.alert({
            message: '请选择付款账号！',
          });
          return false;
      }
      if (this.payer_bank_form.pay_amount == '') {
        this.$dialog.alert({
          message: "请输入付款金额！",
        });
        return false;
      }
      // console.log(this.payer_bank_form)
      // return false;
      
      this.$dialog
        .confirm({
          message: "确认付款"+this.payer_bank_form.pay_amount+"元？",
        })
        .then((res) => {
          this.$http
            .post("flow/confirm_pay_amount", this.payer_bank_form)
            .then((res) => {
              this.$dialog
                .alert({
                  message: res.data.msg,
                })
                .then((res) => {
                  location.reload();
                });
            });
        });
    },
    //重新提交
    resubmit() {
      console.log(this.flow.catalog.component);
      // return false;
      this.$router.push({
        name: this.flow.catalog.component,
        query: {
          from_flow_id: this.flowForm.flow_id,
          classify: this.flow.classify,
        },
      });
    },
    //打印
    print() {
      this.$router.push({
        name: "Print",
        params: {id: this.flowForm.flow_id },
      });
    },
    //撤销退款
    refund_cancel() {
      this.$dialog
        .alert({
          message: "确定作废退款？",
        })
        .then((res) => {
          this.$http
            .post("refund/refund_cancel", { flow_id: this.flow.id })
            .then((res) => {
              console.log(res);
              this.$dialog
                .alert({
                  message: res.data.msg,
                })
                .then((res) => {
                  location.reload();
                });
            });
        });
    },
  },
  watch:{
    flow:function(val){
      this.pay_amount = this.flow.no_pay_amount
      this.payer_bank_form.pay_amount = this.flow.no_pay_amount
    },
    users:function(val){
      this.user.data = val
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.bottom {
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  /* height:140px; 
  
  z-index:99; 
  padding-top:10px;
  padding-bottom:30px;
  background-color: #eee; */
}
.bottom .mu-card {
  height: 100px;

  z-index: 99;
  padding-top: 10px;
  padding-bottom: 30px;
  background-color: #eee;
}

.user_top {
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 2;
}
.user_content {
  margin-top: 110px;
}
.comment {
  margin-bottom: 10px;
}

</style>
<style>
/* .mu-dialog-wrapper, .mu-dialog, .mu-dialog-body{
  max-height:none !important;
} */
.mu-dialog-fullscreen .mu-dialog-body {
  padding: 0;
  max-height: 1200px !important;
}

</style>